import SchedulerComponent from "../Component";
import { FiltersProvider } from "../../TimeSheet/filtersContext";
import { DateFiltersProvider } from "../Component/hooks/useDateFilters";

function Home() {
    return (
        <FiltersProvider
            sessionKey="SCHEDULER_HOME_FILTERS"
            initialValue={
                [{
                    name: "hourType",
                    method: "contains",
                    value: undefined,
                }]
            }
        >
            <DateFiltersProvider>
                <SchedulerComponent />
            </DateFiltersProvider>
        </FiltersProvider>
    );
}

export default Home;
